import { render, staticRenderFns } from "./Renumber.vue?vue&type=template&id=226e9ebc&scoped=true"
import script from "./Renumber.vue?vue&type=script&lang=js"
export * from "./Renumber.vue?vue&type=script&lang=js"
import style0 from "./Renumber.vue?vue&type=style&index=0&id=226e9ebc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e9ebc",
  null
  
)

export default component.exports